import img1 from '../images/icon/icon-10.svg'
import img2 from '../images/icon/icon-11.svg'
import img3 from '../images/icon/icon-12.svg'
import img4 from '../images/icon/icon-13.svg'

const dataCreate = [
    {
        img: img1,
        title: 'Set Up Your Wallet',
        desc: 'Sed ut perspiciatis unde omnste natus error sit voluptatem'
    },
    {
        img: img2,
        title: 'Create Your Collection',
        desc: 'Sed ut perspiciatis unde omnste natus error sit voluptatem'
    },
    {
        img: img3,
        title: 'Add Your NFTs',
        desc: 'Sed ut perspiciatis unde omnste natus error sit voluptatem',
        class:'mg-bt-0'
    },
    {
        img: img4,
        title: 'List Them For Sale',
        desc: 'Sed ut perspiciatis unde omnste natus error sit voluptatem',
        class:'mg-bt-0'
    },  
]

export default dataCreate;